import { Menu } from "@/types/menu";

const menuData: Menu[] = [
	{
		id: 1,
		title: "Home",
		path: "/",
		newTab: false,
	},
	{
		id: 2,
		title: "About Us",
		path: "/about",
		newTab: false,
	},
	{
		id: 3,
		title: "Products",
		newTab: false,
		submenu: [
			{
				id: 41,
				title: "Spanda Pro",
				path: "/products1",
				newTab: false,
			},
			{
				id: 42,
				title: "Spanda Elite",
				path: "/products",
				newTab: false,
			},
			{
				id: 43,
				title: "Spanda DAT",
				path: "/productDAT",
				newTab: false,
			},
		],
	},
	{
		id: 4,
		title: "Technology",
		path: "/technology",
		newTab: false,
	},
	{
		id: 5,
		title: "Application",
		path: "/usecases",
		newTab: false,
	},
	{
		id: 6,
		title: "Support",
		newTab: false,
		submenu: [
			{
				id: 61,
				title: "Contact",
				path: "/contact",
				newTab: false,
			},
			{
				id: 62,
				title: "Downloads",
				path: "/download",
				newTab: false,
			},
			{
				id: 63,
				title: "FAQ",
				path: "/faq",
				newTab: false,
			},
			{
				id: 64,
				title: "Privacy Policy",
				path: "/privacy",
				newTab: false,
			},
			{
				id: 65,
				title: "Warranty Policy",
				path: "/warranty",
				newTab: false,
			},
			{
				id: 66,
				title: "Registration",
				path: "/register",
				newTab: false,
			}
		],
	},
	{
		id: 5,
		title: "Purchase",
		path: "/dealer",
		newTab: false,
	},
	{
		id: 7,
		title: "Blogs",
		path: "/blog",
		newTab: false,
	},
	{
		id: 8,
		title: "Events",
		path: "/events",
		newTab: false,
	}
];
export default menuData;
